export const GOOGLE_MAPS_ZOOM = 15;
export const GOOGLE_MAPS_KEY = 'AIzaSyAKnqtwMWztlm-3fwrQvpTL9ryJHFXuSD0';
